import { z } from 'zod/v4';

// Comma-separated list of preference keys — faithful port of the legacy
// `keys` querystring param. Omit to get all preferences.
export const GetMyPreferencesQuerySchema = z.object({
  keys: z.string().optional(),
});
export type GetMyPreferencesQuery = z.infer<typeof GetMyPreferencesQuerySchema>;

export const GetMyPreferencesResponseSchema = z.record(z.string(), z.unknown());
export type GetMyPreferencesResponseView = z.infer<
  typeof GetMyPreferencesResponseSchema
>;
